<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">充提系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>交易对成本图表分析</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-date-picker
          v-model="time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        />
        <div>目标币种:</div>
        <coin-select
          :coinType="exchangeCoin"
          @value="(val) => (exchangeCoin = val)"
        />
        <div>锚定币种:</div>
        <coin-select
          :coinType="anchoredCoin"
          @value="(val) => (anchoredCoin = val)"
        />
        <el-input
          style="width: 400px"
          v-model="userIds"
          placeholder="输入用户ID 以英文逗号(,)隔开"
        />
        <el-button type="primary" @click="resetVisual()">查询</el-button>
        <create
          @onChange="getFlow()"
          :coinTypes="
            exchangeCoin && anchoredCoin && [exchangeCoin, anchoredCoin]
          "
          :userIds="userIds && userIds.trim().split(',')"
        />
        <list @onChange="getFlow()" />
      </div>

      <div ref="charts" style="margin-top: 20px; height: 350px"></div>
      <div ref="charts2" style="margin-top: 20px; height: 350px"></div>
      <div ref="charts3" style="margin-top: 20px; height: 350px"></div>
    </el-card>
  </div>
</template>

<script>
import "./store";
import coinSelect from "../../components/coinSelect";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Create from "./components/create";
import List from "./components/list";
import { Message } from "element-ui";

const getOptions = (title, legend, xData, series, opts) => {
  return {
    title: {
      text: title,
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      data: legend,
    },
    toolbox: {
      feature: {
        saveAsImage: {},
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        data: xData,
      },
    ],
    yAxis: [
      {
        type: "value",
      },
    ],
    series: series,
    ...opts,
  };
};

export default {
  name: "SnapshotStatistic",
  data() {
    return {
      time: [],
      userIds: "",
      exchangeCoin: "",
      anchoredCoin: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近三天",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(3, "day").startOf("day").toDate(),
                moment().endOf("day").toDate(),
              ]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(7, "day").startOf("day").toDate(),
                moment().endOf("day").toDate(),
              ]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(1, "month").startOf("month").toDate(),
                moment().endOf("month").toDate(),
              ]);
            },
          },
          {
            text: "最近两个月",
            onClick(picker) {
              const end = new Date();
              picker.$emit("pick", [
                moment().subtract(2, "month").startOf("month").toDate(),
                moment().endOf("month").toDate(),
              ]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("snapshotStatistic", [
      "formattedStatistics",
      "statisticsSnapshotTimes",
      "formattedCostingStatistics",
      "formattedPriceStatistics",
    ]),
    params() {
      return {
        from: this.time && this.time[0] && this.time[0].getTime(),
        to: this.time && this.time[1] && this.time[1].getTime(),
        userIds: this.userIds,
        pair:
          this.exchangeCoin &&
          this.anchoredCoin &&
          [this.exchangeCoin, this.anchoredCoin].join("_"),
      };
    },
    chartOptions() {
      return getOptions(
        "余额快照可视化图表",
        this.formattedStatistics.map((item) => item.name),
        this.statisticsSnapshotTimes,
        this.formattedStatistics,
        {
          // yAxis: [
          //   {
          //     type: "value",
          //     // max: function (value) {
          //     //   return Math.ceil(value.max);
          //     // },
          //     axisPointer: {
          //       snap: true,
          //     },
          //     name: "余额",
          //   },
          //   {
          //     type: "value",
          //     // min: function (value) {
          //     //   return Math.floor(value.min);
          //     // },
          //     // max: function (value) {
          //     //   return Math.ceil(value.max);
          //     // },
          //     name: "净流入/流出",
          //   },
          // ],
          legend: {
            data: this.formattedStatistics.map((item) => item.name),
            selected: {
              ...this.formattedStatistics.reduce(
                (map, item) => ({ ...map, [item.name]: !item.hide }),
                {}
              ),
            },
          },
        }
      );
    },
    chartCostingOptions() {
      return getOptions(
        "成本可视化图表",
        this.formattedCostingStatistics.map((item) => item.name),
        this.statisticsSnapshotTimes,
        this.formattedCostingStatistics,
        {
          yAxis: [
            {
              type: "value",
              min: function (value) {
                return Math.floor(value.min - Math.abs((value.max - value.min) / 2));
              },
              max: function (value) {
                return Math.ceil(value.max + Math.abs((value.max - value.min) / 2));
              },

              axisPointer: {
                snap: true,
              },
              name:
                "成本" +
                `(${
                  this.formattedStatistics[1] &&
                  this.formattedStatistics[1].name
                })`,
            },
            {
              type: "value",
              min: function (value) {
                return Math.floor(value.min - Math.abs((value.max - value.min) / 5));
              },
              max: function (value) {
                return Math.ceil(value.max + Math.abs((value.max - value.min) / 5));
              },
              axisPointer: {
                snap: true,
              },
              name:
                "利润" +
                `(${
                  this.formattedStatistics[1] &&
                  this.formattedStatistics[1].name
                })`,
            },
          ],
        }
      );
    },
    chartPriceOptions() {
      return getOptions(
        "价格可视化图表",
        this.formattedPriceStatistics.map((item) => item.name),
        this.statisticsSnapshotTimes,
        this.formattedPriceStatistics,
        {
          yAxis: {
            min: function (value) {
              return Math.floor(value.min);
            },
            max: function (value) {
              return Math.ceil(value.max);
            },
          },
        }
      );
    },
  },
  watch: {
    chartOptions(val) {
      let chart = this.$echarts.init(this.$refs.charts);
      chart.setOption(val);
    },
    chartCostingOptions(val) {
      console.log(val);
      let chart = this.$echarts.init(this.$refs.charts2);
      chart.setOption(val);
    },
    chartPriceOptions(val) {
      let chart = this.$echarts.init(this.$refs.charts3);
      chart.setOption(val);
    },
  },
  components: {
    coinSelect,
    Create,
    List,
  },
  methods: {
    ...mapActions("snapshotStatistic", ["getStatistics", "listFlow"]),
    examParams(showMessage) {
      if (!this.params.from || !this.params.to) {
        showMessage && Message.error({ message: "请选择时间范围" });
        return;
      }
      if (!this.params.pair) {
        showMessage && Message.error({ message: "请选择交易对" });
        return;
      }
      if (!this.params.userIds) {
        showMessage && Message.error({ message: "请输入用户ID" });
        return;
      }
      return true;
    },
    resetVisual() {
      if (!this.examParams(true)) return;
      this.getStatistics(this.params);
      this.getFlow();
    },
    getFlow() {
      if (!this.examParams()) return;
      this.listFlow(this.params);
    },
  },
  created() {},
  mounted() {
    // this.resetVisual();
  },
};
</script>

<style scoped>
</style>
